// MobileBoHHome — back-of-house role landing screen.
// Quick-actions for: Temperature log · Stock count · Waste log · Checklists.
import React from 'react';
import { Link } from 'react-router-dom';
import {
  Thermometer, ClipboardList, Trash2, ListChecks, ArrowRight, ChefHat, ShieldAlert, Truck
} from 'lucide-react';
import MobileOfflineBanner from './MobileOfflineBanner';
import QuickInvoicePhoto from './QuickInvoicePhoto';

const ACTIONS = [
  {
    to: '/mobile/boh/temperature',
    label: 'Temperature Log',
    sub: 'Fridges, walk-ins, prep surfaces',
    Icon: Thermometer,
    testid: 'boh-action-temperature',
  },
  {
    to: '/mobile/boh/stock-count',
    label: 'Stock Count',
    sub: 'Barcode scan or manual entry',
    Icon: ClipboardList,
    testid: 'boh-action-stock-count',
  },
  {
    to: '/mobile/receiving',
    label: 'Receive a delivery',
    sub: 'Photograph the note, enter quantities',
    Icon: Truck,
    testid: 'boh-action-receiving',
  },
  {
    to: '/mobile/alerts',
    label: 'Alerts',
    sub: 'Acknowledge, snooze, escalate',
    Icon: ShieldAlert,
    testid: 'boh-action-alerts',
  },
  {
    to: '/mobile/safety',
    label: 'Checklists & Incidents',
    sub: 'Pre-open, mid-shift, close',
    Icon: ListChecks,
    testid: 'boh-action-checklists',
  },
  {
    to: '/mobile/inventory',
    label: 'Waste / Adjustments',
    sub: 'Spoilage, prep loss, overproduction',
    Icon: Trash2,
    testid: 'boh-action-waste',
  },
];

const MobileBoHHome = () => {
  return (
    <div className="min-h-screen bg-surface-muted" data-testid="boh-home-page">
      <MobileOfflineBanner />

      <div className="bg-primary-500 text-surface px-4 pt-6 pb-10">
        <div className="flex items-center gap-2 text-xs uppercase tracking-overline opacity-80">
          <ChefHat className="w-3.5 h-3.5" /> Back of House
        </div>
        <h1 className="font-display text-2xl mt-1">Good shift. Pick a job.</h1>
        <p className="text-sm opacity-80 mt-1">Everything below works offline — your taps are saved and synced when you’re back online.</p>
      </div>

      <div className="-mt-6 mb-3"><QuickInvoicePhoto /></div>

      <div className="px-4 space-y-3 pb-24">
        {ACTIONS.map(({ to, label, sub, Icon, testid }) => (
          <Link
            key={to}
            to={to}
            className="block bg-surface border border-surface-border rounded-lg px-4 py-4 shadow-ambient hover:shadow-lift motion-organic"
            data-testid={testid}
          >
            <div className="flex items-center gap-3">
              <span className="w-10 h-10 rounded-md bg-primary-50 flex items-center justify-center">
                <Icon className="w-5 h-5 text-primary-500" />
              </span>
              <div className="flex-1">
                <div className="font-display text-base text-ink">{label}</div>
                <div className="text-xs text-ink-muted mt-0.5">{sub}</div>
              </div>
              <ArrowRight className="w-4 h-4 text-ink-muted" />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default MobileBoHHome;
